
export const TOKEN_IEnvironment = Symbol('IEnvironment');

export interface IEnvironment {
    get isProd(): boolean;
    get backendUrl(): string;
}